import React from 'react';
import { tUi } from '../../../../../../../../utils/dq_lc';
import { SlideTitle } from '../../../../../styles/LearnTab/slideBase.styles';
import {
  AssessmentResultContainer,
  ResultContent,
  ResultBody,
  ScoreContainer,
  ScoreContent,
  ScoreSpinner,
  ScoreLabelPt,
  ScoreDesc,
  RubricContainer,
  RubricTable,
} from '../../../../../styles/LearnTab/rubric.styles';

// Rubric rows, top to bottom. Keys are written out in full so they can be grepped.
// `upper` is the top of the row's band on the 0-100 scale, printed on the row's top edge.
const RUBRIC_ROWS = [
  { level: 4, upper: 100, labelKey: 'slide.assessment.rubricHigh', descKey: 'slide.assessment.rubricHighDesc' },
  { level: 3, upper: 75, labelKey: 'slide.assessment.rubricModerate', descKey: 'slide.assessment.rubricModerateDesc' },
  { level: 2, upper: 50, labelKey: 'slide.assessment.rubricBasic', descKey: 'slide.assessment.rubricBasicDesc' },
  { level: 1, upper: 25, labelKey: 'slide.assessment.rubricLow', descKey: 'slide.assessment.rubricLowDesc' },
];
// Bottom of the scale, printed under the last row.
const SCALE_FLOOR = 0;

export const AssessmentResultSlide = ({
  slide,
  highlightWord,
  uiLocale = 'en-US',
}) => {
  const localizeAssessmentScoreTitle = (rawTitle) => {
    if (!rawTitle) return rawTitle;
    if (!uiLocale || uiLocale === 'en-US') return rawTitle;
    if (String(rawTitle).trim().toLowerCase() === 'your session assessment score') {
      return tUi('slide.assessment.sessionScoreTitle', uiLocale);
    }
    const m = String(rawTitle).match(/^\s*Your Module\s*(\d+)\s*Assessment Score\s*$/i);
    if (m) return tUi('slide.assessment.moduleScoreTitle', uiLocale, { module: m[1] });
    if (String(rawTitle).trim().toLowerCase() === 'your module assessment score') {
      return tUi('slide.assessment.moduleScoreTitleGeneric', uiLocale);
    }
    return rawTitle;
  };

  const localizedResultTitle = localizeAssessmentScoreTitle(slide?.SlideTitle);
  const score = parseFloat(slide?.SlideContent?.score || 0).toFixed(2);
  const [scoreInt, scoreDec] = score.split('.');

  return (
    <AssessmentResultContainer>
      <ResultContent>
        <SlideTitle style={{ textAlign: 'center' }}>
          {highlightWord ? highlightWord('title', localizedResultTitle) : localizedResultTitle}
        </SlideTitle>
        <ResultBody>
          <ScoreContainer>
            <ScoreContent>
              <ScoreSpinner>
                <span>{scoreInt}</span>
                <ScoreLabelPt>.{scoreDec}</ScoreLabelPt>
              </ScoreSpinner>
              <ScoreDesc>{slide?.SlideContent?.description || tUi('slide.activity.yourSessionScore', uiLocale)}</ScoreDesc>
            </ScoreContent>
            <RubricContainer>
              <RubricTable>
                <thead>
                  <tr>
                    <td data-scale aria-hidden="true" />
                    <th scope="col">{tUi('slide.assessment.rubricLevel', uiLocale)}</th>
                    <th scope="col">{tUi('slide.assessment.rubricDescription', uiLocale)}</th>
                  </tr>
                </thead>
                <tbody>
                  {RUBRIC_ROWS.map(({ level, upper, labelKey, descKey }, index) => (
                    <tr key={level}>
                      <td data-scale={level} aria-hidden="true">
                        <span>{upper}</span>
                        {index === RUBRIC_ROWS.length - 1 && <span data-scale-floor>{SCALE_FLOOR}</span>}
                      </td>
                      <td data-level={level}>{tUi(labelKey, uiLocale)}</td>
                      <td>{tUi(descKey, uiLocale)}</td>
                    </tr>
                  ))}
                </tbody>
              </RubricTable>
            </RubricContainer>
          </ScoreContainer>
        </ResultBody>
      </ResultContent>
    </AssessmentResultContainer>
  );
};

export default AssessmentResultSlide;
